// extracted by mini-css-extract-plugin
export default {"userAccess":"userAccess__aqykh","modal":"modal__kLoi1","embeded":"embeded__EYsBh","userAccess__list":"userAccess__list__JE_qZ"};